var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "metric-panel" },
    [
      _c("div", { staticClass: "metric-panel__header" }, [
        _c("div", { staticClass: "metric-panel__title-wrap" }, [
          _c("span", {
            staticClass: "metric-panel__dot",
            style: { background: _vm.color },
          }),
          _c("div", [
            _c("div", { staticClass: "metric-panel__title" }, [
              _vm._v(_vm._s(_vm.title)),
            ]),
            _c("div", { staticClass: "metric-panel__desc" }, [
              _vm._v(_vm._s(_vm.desc)),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "metric-panel__total" }, [
          _vm._v(" 合计 "),
          _c("span", [_vm._v("¥ " + _vm._s(_vm.formatAmount(_vm.total)))]),
        ]),
      ]),
      _vm.rows.length
        ? _c(
            "el-table",
            {
              attrs: {
                data: _vm.rows,
                size: "small",
                "max-height": "300",
                "header-cell-style": {
                  background: "#fafafa",
                  color: "#606266",
                },
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "index", label: "#", width: "48" },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.nameLabel,
                  prop: "name",
                  "min-width": "120",
                  "show-overflow-tooltip": "",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "金额(元)",
                  prop: "amount",
                  width: "120",
                  align: "right",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(_vm.formatAmount(scope.row.amount)) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  46442719
                ),
              }),
              _c("el-table-column", {
                attrs: { label: "占比", width: "140", align: "center" },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticClass: "ratio-cell" },
                            [
                              _c("el-progress", {
                                attrs: {
                                  percentage: _vm.getPercent(scope.row.amount),
                                  color: _vm.color,
                                  "show-text": false,
                                  "stroke-width": 8,
                                },
                              }),
                              _c("span", { staticClass: "ratio-text" }, [
                                _vm._v(
                                  _vm._s(_vm.getPercent(scope.row.amount)) + "%"
                                ),
                              ]),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  2938458241
                ),
              }),
            ],
            1
          )
        : _c("div", { staticClass: "metric-panel__empty" }, [
            _vm._v("暂无数据"),
          ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }